import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets the provider data.
 */
export const getProvider = factoryAuthService(({ dni, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/organismSupplier/getKPI/${year}/${dni}`)
)

/**
 * Gets the provider distribution by the given dni, mechanism, sector, and year.
 */
export const getProviderSalesDistribution = factoryAuthService(({ dni, mechanismId, sectorId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/organismSupplier/detail/${year}/${dni}/${mechanismId}/${sectorId}`)
)

/**
 * Gets the purchasing mechanisms of the given dni of the given year.
 */
export const getProviderPurchasingMechanisms = factoryAuthService(({ dni, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/organismSupplier/modality/${year}/${dni}`)
)

/**
 * Gets the traded amounts by the given dni, mechanism, and year.
 */
export const getProviderTradedAmounts = factoryAuthService(({ dni, mechanismId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/organismSupplier/traded/${year}/${dni}/${mechanismId}`)
)
